/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseDocumentsEditorViewModel } from "../types/CourseDocumentsEditorViewModel.ts";
import { courseDocumentsLangEditorViewModelSchema } from "./courseDocumentsLangEditorViewModelSchema.ts";
import { eEnrollmentStatusSchema } from "./eEnrollmentStatusSchema.ts";
import { eScholarshipStatusSchema } from "./eScholarshipStatusSchema.ts";

export const courseDocumentsEditorViewModelSchema = z.object({
  courseId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID do curso que receberá o vínculo. Obrigatório e imutável na atualização.",
      ),
  ),
  documentId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID do documento-modelo a reaproveitar. Informe zero para criar um novo documento na empresa do curso. Imutável na atualização.",
      ),
  ),
  documentName: z
    .string()
    .describe("Nome do documento. Obrigatório, máximo de 100 caracteres.")
    .nullish(),
  isFile: z.optional(
    z
      .boolean()
      .describe(
        "Define se a declaração é entregue como arquivo PDF. Quando verdadeiro, o conteúdo HTML enviado é ignorado.",
      ),
  ),
  useDigitalValidation: z.optional(
    z
      .boolean()
      .default(true)
      .describe("Define se a declaração usa validação digital."),
  ),
  usePortuguese: z.optional(
    z
      .boolean()
      .default(true)
      .describe(
        "Define se a declaração está habilitada em português. Precisa ser verdadeiro: o português é obrigatório.",
      ),
  ),
  useEnglish: z.optional(
    z
      .boolean()
      .describe(
        "Define se a declaração está habilitada em inglês. Quando verdadeiro e o conteúdo compartilhado é atualizado, o nome em inglês passa a ser obrigatório.",
      ),
  ),
  useSpanish: z.optional(
    z
      .boolean()
      .describe(
        "Define se a declaração está habilitada em espanhol. Quando verdadeiro e o conteúdo compartilhado é atualizado, o nome em espanhol passa a ser obrigatório.",
      ),
  ),
  allowedEnrollmentStatus: z
    .array(
      z
        .lazy(() => eEnrollmentStatusSchema)
        .describe(
          "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
        ),
    )
    .describe(
      "Status de matrícula que permitem ao aluno visualizar a declaração. Lista vazia libera para todos. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
    )
    .nullish(),
  allowedScholarshipStatus: z
    .array(
      z
        .lazy(() => eScholarshipStatusSchema)
        .describe(
          "1 = Interested | 2 = InProcess | 3 = ScholarshipHolder | 4 = Refused | 5 = RefusedInterested | 6 = RefusedPotential | ",
        ),
    )
    .describe(
      "Status de bolsa que permitem ao aluno visualizar a declaração. Lista vazia libera para todos. Enum EScholarshipStatus: `1` = Interested, `2` = InProcess, `3` = ScholarshipHolder, `4` = Refused, `5` = RefusedInterested, `6` = RefusedPotential.",
    )
    .nullish(),
  updateSharedContent: z.optional(
    z
      .boolean()
      .describe(
        "Define se o nome do documento e os conteúdos por idioma devem ser gravados. Como esse conteúdo é compartilhado com os demais cursos vinculados ao mesmo documento, o padrão é falso. Quando falso, o campo Languages é ignorado por completo e não é validado.",
      ),
  ),
  languages: z
    .array(z.lazy(() => courseDocumentsLangEditorViewModelSchema))
    .describe(
      "Conteúdos por idioma a gravar, identificados pela cultura. Considerado e validado apenas quando UpdateSharedContent é verdadeiro. Envie somente os idiomas marcados como editáveis no retorno do GET.",
    )
    .nullish(),
}) as unknown as ToZod<CourseDocumentsEditorViewModel>;
